import React from 'react';

/** V1 (`Home/Inicio.jsx`): pantalla de inicio = solo el logo Sistemify centrado, sin texto ni tarjetas. */
export default function Inicio() {
  return (
    <div className="flex justify-center">
      <img src="/LogoSistemify2.png" alt="auto" className="max-w-full" style={{ width: '90%' }} />
    </div>
  );
}
